import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import ClipLoader from "react-spinners/ClipLoader";
interface Props {
  isLoading: boolean;
  onVerify: (code: string) => void;
  handleBack: (page: string) => void
}

const OtpInput: React.FC<Props> = ({ onVerify, handleBack, isLoading }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    onVerify(otp)
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col items-center space-y-5 w-full mx-auto"
    >
      <div className="absolute top-16 left-4 text-2xl" onClick={()=>handleBack("phone")}>
        ←
      </div>
      <div className="items-center justify-center mt-10 bg-gray-100 rounded-full p-2">
        <ShieldCheck className="w-16 h-16 p-2 grayscale opacity-20" />
      </div>
      <div className="mt-10">
        <h2 className="font-bold text-[16px] text-center">
          인증 번호를 입력해주세요
        </h2>
      </div>
      <div className="relative w-full">
        <div
          className={`flex items-center border overflow-hidden bg-gray-100 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        >
          <input
            type="tel"
            placeholder="238FGHD"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="flex-1 text-sm outline-none bg-white py-2 pr-4"
          />
        </div>

        {error && (
          <p className="text-red-500 text-xs mt-1 text-center">{error}</p>
        )}

        <div className="w-full text-center mt-20">
          <button
            onClick={handleSubmit}
            type="button"
            className="text-white border-gray-500 shadow-md rounded-sm  bg-[#384D92] border p-2 mt-2 text-xs mt-1 text-center item-center w-full"
          >
            {!isLoading ? <>확인</> : <ClipLoader size={16}/>}
          </button>
        </div>
      </div>
    </form>
  );
};

export default OtpInput;
